import { connect } from 'react-redux';
import { ShiftDayModal as Modal } from './ShiftDayModal';

const mapStateToProps = ({ shifts }) => ({
  venue: shifts.venue,
  isSavingShift: shifts.isSavingShift,
});

export const ShiftDayModal = connect(mapStateToProps)(Modal);
